module.exports = __webpack_public_path__ + "static/media/ho-full-width.196cac27.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/ho-full-width.png
// module id = 790
// module chunks = 0